// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"16c5e5eb","455":"7d8a71ad","977":"94c7ac56"}[chunkId] + ".chunk.js";
};